<template>
    <v-navigation-drawer
      app
      clipped
      right
      v-model="PROCESS_DOCU_DRAWER_STATE"
      :mini-variant="isMini"
      permanent
      mini-variant-width="50"
      :class="{'drawer-mini': !PROCESS_DOCU_DRAWER_STATE}"
      width="440"
  >
    <div v-show="!isMini">
      <v-btn class="pa-5" icon @click.stop="TOOGLE_PROCESS_DOCU_DRAWER_STATE">
        <v-icon color="primary">close</v-icon>
      </v-btn>
    </div>
    <div v-show="isMini" class="text-center">
      <v-btn class="pa-5" icon @click.stop="TOOGLE_PROCESS_DOCU_DRAWER_STATE">
        <v-icon color="primary">link</v-icon>
      </v-btn>
    </div>

    <v-divider v-show="!isMini"></v-divider>

    <v-expansion-panels v-show="!isMini" tile accordion>
      <!-- Docu expansion panel -->
      <v-expansion-panel>
        <v-expansion-panel-header>
          <v-row align="center">
            <v-col cols="1"><v-icon>description</v-icon></v-col>
            <v-col>
              <span class="red-dot"></span>
              <span class="ml-2">{{ $t('common:documentation_plural')}} ({{ documentations.length }})</span>
            </v-col>
          </v-row>
        </v-expansion-panel-header>
        <v-expansion-panel-content eager>
          <v-list>
            <v-list-item-group>
              <v-list-item v-for="item in documentations" :key="item.id" @click="$emit('viewDocument' , item)" class="mb-1 py-0 px-3">
                <v-row>
                  <v-col align-self="center">
                    <span class="ml-2">{{ item.name }}</span>
                  </v-col>
                  <v-col class="text-right">
                    <v-btn icon color="primary" @click.native.stop="$emit('downloadDocument', item)">
                      <v-icon>cloud_download</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-navigation-drawer>
</template>

<script>
import {mapActions, mapState} from 'vuex'

export default {
  name: 'ProcessDocuDrawer',
  data() {
    return {
      documentations: []
    }
  },
  computed: {
    ...mapState('book/layout', {
      processDocuDrawer: state => state.processDocuDrawer
    }),
    PROCESS_DOCU_DRAWER_STATE: {
      get() {
        return this.processDocuDrawer
      },
      set(newValue) {
        if (newValue === this.processDocuDrawer) return;
        this.TOOGLE_PROCESS_DOCU_DRAWER_STATE();
      }
    },
    isMini() {
      // if screen size is md or lower
      if(this.$vuetify.breakpoint.mdAndDown) {
        return this.PROCESS_DOCU_DRAWER_STATE
      } else {
        return !this.PROCESS_DOCU_DRAWER_STATE
      }
    }
  },
  methods: {
    ...mapActions(
        'book/layout', ['TOOGLE_PROCESS_DOCU_DRAWER_STATE']
    ),
  }
}
</script>
<style lang="scss">
  .docu-preview-small {
    border-radius: 10%;  /* Rounded border */
    padding: 5px; /* Some padding */
    width: 50px;
  }
</style>